import React from 'react';
import '../App.css'; // Include your custom CSS for additional styling

const About = () => {
  return (
    <div className="container-fluid my-5 align-items-center">
      <h2 style={{ color: 'rgb(23, 37, 84)', textAlign: 'center', fontWeight: '700' }}>Why Choose Us</h2>
      <br />
      <br />
      <div className="row justify-content-center">
        {/* Upper 3 columns */}
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>Fast and Reliable</h4>
          <br />
          <p>
            Whether you’re transferring a massive work project, streaming the latest entertainment, making a call, or uploading selfies, you can do it all without interruption.
          </p>
        </div>
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>Best Way to Work and Play</h4>
          <br />
          <p>
            Talk to your loved ones or business colleagues without dropped calls. Don't miss out on those important moments!
          </p>
        </div>
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>Better Internet = Better Homes</h4>
          <br />
          <p>
            A Fibre connection allows you to enjoy better entertainment, education, and security, all while adding resale value to your home.
          </p>
        </div>
      </div>
      {/* Add spacing between upper and lower rows */}
      <div className="row justify-content-center mt-5">
        {/* Lower 3 columns */}
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>The Future of Entertainment</h4>
          <br />
          <p>
            Enjoy more movies, series, music, and online gaming than ever before with fast and reliable Fibre.
          </p>
        </div>
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>Believe in Life After ADSL</h4>
          <br />
          <p>
            Transition from ADSL to Fibre for a faster, more cost-effective internet experience.
          </p>
        </div>
        <div className="col-md-3 mb-4 about-block">
          <h4 style={{ color: 'rgb(23, 37, 84)', fontWeight: '700' }}>Free Installation</h4>
          <br />
          <p>
            Our experienced technicians will install your Fibre connection quickly and neatly at no cost.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
